export default __webpack_public_path__ + "static/srtip-pool-bfcf39ec3b326844aacdfa8f198c60ea.jpg";